import { ReactiveVar } from 'meteor/reactive-var'
import { ShowWarningLawyer } from '../components/ShowLawyer'
import { RESET_SEARCH } from '../reducers/searchLawyer'
import { dispatch } from '../store'

const FILTERS = {
  page: new ReactiveVar(1),
  barreaux: new ReactiveVar(),
  languages: new ReactiveVar(),
  experience: new ReactiveVar(),
  domaineId: new ReactiveVar(),
}

const resetFilters = () => {
  FILTERS.page.set(1)
  FILTERS.barreaux.set()
  FILTERS.languages.set()
  FILTERS.experience.set()
  FILTERS.domaineId.set()
  ShowWarningLawyer.set(false)

  dispatch({ type: RESET_SEARCH })
}

export { FILTERS, resetFilters }
